module.exports = __webpack_public_path__ + "img/login.8aea2cbc.svg";